import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pwa-login-page" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "logo-section" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "checkbox-group" }
const _hoisted_11 = { class: "checkbox-label" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "loading-text"
}
const _hoisted_16 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import LodingComponent from '@/components/loading/LodingComponent.vue';

interface LoginData {
  loginId: string;
  loginPw: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaLogin',
  setup(__props) {

const store = useStore();
const router = useRouter();

const logoImage = ref(new URL('../../assets/images/hypehive-logo.png', import.meta.url).href);

const loginData = ref<LoginData>({
  loginId: '',
  loginPw: ''
});

const saveId = ref(false);
const loginForm = ref();
const isSubmitting = ref(false);

const isFormValid = computed(() => {
  return loginData.value.loginId.trim() !== '' && 
         loginData.value.loginPw.trim() !== '';
});

const loading = computed(() => store.getters['pwa/pwaLoginLoading'] || isSubmitting.value);

const handleLogin = async () => {
  if (!isFormValid.value || isSubmitting.value) return;
  
  isSubmitting.value = true;
  
  try {
    // PWA 전용 로그인 사용 (hh_member + hh_emp 통합)
    const result = await store.dispatch('pwa/performPwaLogin', {
      loginId: loginData.value.loginId,
      loginPw: loginData.value.loginPw
    });
    
    if (result.success) {
      if (saveId.value) {
        localStorage.setItem('savedLoginId', loginData.value.loginId);
      } else {
        localStorage.removeItem('savedLoginId');
      }
      
      // 사용자 타입에 따라 다른 경로로 이동
      // manager: 센터장/관리자 (hh_member) -> /pwa/home
      // boss: 대표자 (hh_emp, emp_isboss='Y') -> /emp/home
      // employee: 일반 사원 (hh_emp) -> /emp/home
      
      // userType에 따라 적절한 홈으로 이동
      if (result.userType === 'employee' || result.userType === 'boss') {
        router.push('/emp/home');
      } else {
        router.push('/pwa/home');
      }
    } else {
      loginData.value.loginPw = '';
      setTimeout(() => {
        const passwordField = document.querySelector('input[type="password"]') as HTMLInputElement;
        if (passwordField) {
          passwordField.focus();
        }
      }, 100);
    }
  } catch (error: any) {
    console.error('로그인 오류:', error);
    loginData.value.loginPw = '';
    setTimeout(() => {
      const passwordField = document.querySelector('input[type="password"]') as HTMLInputElement;
      if (passwordField) {
        passwordField.focus();
      }
    }, 100);
  } finally {
    isSubmitting.value = false;
  }
};

const handleSignup = () => {
  router.push('/pwa/signup');
};

onMounted(() => {
  // 저장된 아이디 불러오기
  const savedLoginId = localStorage.getItem('savedLoginId');
  if (savedLoginId) {
    loginData.value.loginId = savedLoginId;
    saveId.value = true;
  }
  
  // PWA 로그인 상태 확인 (이미 로그인되어 있는지)
  // 주의: 로그인 페이지에서는 API 호출 없이 로컬 상태만 확인
  const pwaUser = store.getters['pwa/pwaUser'];
  if (pwaUser) {
    router.push('/pwa/home');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LodingComponent, {
      "is-visible": loading.value,
      text: "로그인 중..."
    }, null, 8, ["is-visible"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: logoImage.value,
          alt: "하이파이브",
          class: "logo-image"
        }, null, 8, _hoisted_4),
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "app-title" }, "하이파이브", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "app-subtitle" }, "재가장기요양센터 관리 시스템", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_form, {
          ref_key: "loginForm",
          ref: loginForm,
          onSubmit: _withModifiers(handleLogin, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_icon, { class: "input-icon" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-account", -1)
                ]))]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.value.loginId) = $event)),
                type: "text",
                class: "form-input",
                placeholder: "아이디",
                disabled: loading.value,
                autocomplete: "username"
              }, null, 8, _hoisted_7), [
                [_vModelText, loginData.value.loginId]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, { class: "input-icon" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-lock", -1)
                ]))]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginData.value.loginPw) = $event)),
                type: "password",
                class: "form-input",
                placeholder: "비밀번호",
                disabled: loading.value,
                autocomplete: "current-password",
                onKeyup: _withKeys(handleLogin, ["enter"])
              }, null, 40, _hoisted_9), [
                [_vModelText, loginData.value.loginPw]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((saveId).value = $event)),
                  type: "checkbox",
                  class: "checkbox-input",
                  disabled: loading.value
                }, null, 8, _hoisted_12), [
                  [_vModelCheckbox, saveId.value]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "checkbox-text" }, "아이디 저장", -1))
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["login-button", { 'loading': loading.value }]),
              disabled: !isFormValid.value || loading.value,
              onClick: handleLogin
            }, [
              (!loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "로그인"))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "로그인 중..."))
            ], 10, _hoisted_13)
          ]),
          _: 1
        }, 512),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, [
          _createElementVNode("span", null, "또는")
        ], -1)),
        _createElementVNode("button", {
          type: "button",
          class: "signup-button",
          disabled: loading.value,
          onClick: handleSignup
        }, " 회원가입 ", 8, _hoisted_16)
      ])
    ])
  ]))
}
}

})